module.exports = __webpack_public_path__ + "img/Vietnam-2-hover.34c0e997.jpg";